module.exports = __webpack_public_path__ + "static/img/img-home-co-06.93554c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-06.png
// module id = kT9J
// module chunks = 1